export default __webpack_public_path__ + "static/media/arrowSelect2.af687943.svg";